import { useEffect } from 'react'
import { create } from 'zustand'

// pageDataStore holds a compact snapshot of what the current page is rendering,
// published by pages that opt in. The assistant drawer reads it so it can explain
// the exact data on screen. Cleared when a page unmounts.
interface PageDataState {
  data: unknown | null
  setPageData: (d: unknown) => void
  clearPageData: () => void
}

export const usePageDataStore = create<PageDataState>((set) => ({
  data: null,
  setPageData: (d) => set({ data: d }),
  clearPageData: () => set({ data: null }),
}))

// usePublishPageData publishes a page's compact rendered data for the assistant,
// and clears it on unmount. Pass a memoized value to avoid redundant updates.
export function usePublishPageData(data: unknown) {
  const setPageData = usePageDataStore((s) => s.setPageData)
  const clearPageData = usePageDataStore((s) => s.clearPageData)
  useEffect(() => {
    setPageData(data ?? null)
    return () => clearPageData()
  }, [data, setPageData, clearPageData])
}
